import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { makeEnum, withVersion } from '../utils';
import { stateIllustrations } from './illustrations';
const { Empty, Error, Search, Success } = stateIllustrations;
export const IllustrationType = makeEnum('empty-state', 'error-state', 'search-state', 'success-state');
export const IllustrationImpl = ({ type, width, height }) => {
    switch (type) {
        case 'empty-state':
            return _jsx(Empty, { width: width, height: height });
        case 'error-state':
            return _jsx(Error, { width: width, height: height });
        case 'search-state':
            return _jsx(Search, { width: width, height: height });
        case 'success-state':
            return _jsx(Success, { width: width, height: height });
    }
};
export const Illustration = withVersion(IllustrationImpl, '1.0.0');
